import { useSelector } from 'react-redux';
import { Briefings, RootState } from '../../shared/store';

export const useBriefings = (): { briefings: Briefings; isLoading: boolean } =>
  useSelector(({ firestore: { data, status } }: RootState) => ({
    briefings: {
      ...data.briefings,
      ...data.customerBriefings,
    },
    isLoading: !(
      status?.requested?.briefings || status?.requested?.customerBriefings
    ),
  }));
